<span class="cp-checkbox">
	<input #input [id]="_id" type="checkbox" [attr.tabindex]="tabindex ? tabindex : null" [disabled]="disabled"
		   (change)="onChange($event.target.checked)" (focus)="focusChange.emit($event);"
		   (blur)="blurChange.emit($event); onTouched()" (click)="clickChange.emit($event)"  [indeterminate]="indeterminate"/>
	<label [attr.for]="_id">{{label}}</label>
</span>
